export { default as Line } from './line';
export { default as Circle } from './circle';
export { default as Base } from './base';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/component/esm/axis/index.js
// module id = null
// module chunks = 